// src/pages/rbac/RBACHome.jsx
import React from 'react';

const RBACHome = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>RBAC Home</h1>
      <p>This is a placeholder page for the RBAC (Role-Based Access Control) module.</p>
    </div>
  );
};

export default RBACHome;